// extracted by mini-css-extract-plugin
export default {"container":"CustomPolygonForm_container__6Egxj"};